import { createContext, useContext } from 'react';

import { DialogState } from '@components/primitives/Dialog/useDialog';

export const DialogContext = createContext<DialogState<any> | null>(null);

export function useDialogContext<T = void>(): DialogState<T> {
  const ctx = useContext(DialogContext);

  if (!ctx) {
    throw new Error('useDialogContext must be used within a Dialog component');
  }

  return ctx;
}
